import DownloadCell from 'components/Cell/Reports/DownloadCell'
import withProps from 'containers/withProps'

export default withProps(
    ({row: {id, exportTypes, status}}) => ({
        id,
        exportTypes,
        disabled: status !== 'succeeded',
    }),
)(DownloadCell)